module.exports = __webpack_public_path__ + "img/QBE_logo_aedecp.d6ebb440.svg";